import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50de924b")

_pushScopeId("data-v-50de924b")
const _hoisted_1 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_2 = { class: "flex-grow flex flex-col px-4 pt-6 overflow-y-scroll" }
const _hoisted_3 = { class: "flex flex-col mb-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "mb-4 font-medium text-lg" }, "獲得バッジ状況", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MSPanelHeader = _resolveComponent("MSPanelHeader")
  const _component_m_badge_card = _resolveComponent("m-badge-card")
  const _component_m_badge_modal = _resolveComponent("m-badge-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MSPanelHeader, {
      "select-page": "badge",
      onOpen: _ctx.open
    }, null, 8, ["onOpen"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("section", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.badgeCardDatas, (data) => {
            return (_openBlock(), _createBlock(_component_m_badge_card, {
              key: data.badge.ref.id,
              badge: data.badge,
              step: data.step,
              class: "mb-4",
              onClick: ($event: any) => (_ctx.setSelectedBadgeId(data.badge.ref.id))
            }, null, 8, ["badge", "step", "onClick"]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.selectedBadgeData)
      ? (_openBlock(), _createBlock(_component_m_badge_modal, {
          key: 0,
          badge: _ctx.selectedBadgeData.badge,
          step: _ctx.selectedBadgeData.step,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSelectedBadgeId('')))
        }, null, 8, ["badge", "step"]))
      : _createCommentVNode("", true)
  ], 64))
})